module.exports = {
  ind: {
    black: 'var(--ind-black)',
    white: 'var(--ind-white)',
    blue: 'var(--ind-blue)',
  },
  blue: {
    DEFAULT: 'var(--ind-blue)',
    dark: 'var(--blue-dark)',
    tertiary: 'var(--blue-tertiary)',
  },
  grey: {
    DEFAULT: 'var(--grey)',
    dark: 'var(--grey-dark)',
    light: 'var(--grey-light)',
    bg: 'var(--grey-bg)',
    tertiary: 'var(--grey-tertiary)',
  },
  red: {
    DEFAULT: 'var(--red)',
    ticker: 'var(--red-ticker)',
    tertiary: 'var(--red-tertiary)',
  },
  orange: {
    DEFAULT: 'var(--orange)',
    tertiary: 'var(--orange-tertiary)',
  },
  yellow: 'var(--yellow)',
  gold: 'var(--gold)',
  green: {
    DEFAULT: 'var(--green)',
    ticker: 'var(--green-ticker)',
    tertiary: 'var(--green-tertiary)',
  },
  spl: {
    white: 'var(--spl-white)',
    black: 'var(--spl-black)',
  },
}
